"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createStakingDataSourcePlugin = exports.perpLaunchpadDataSourcePlugin = void 0;
const context_1 = require("@derivation-tech/context");
const perpLuanchpadDataSource_module_1 = require("./perpLuanchpadDataSource.module");
const sdks_perp_launchpad_1 = require("@synfutures/sdks-perp-launchpad");
const perpLaunchpadDataSourcePlugin = (endpoint) => {
    return {
        install(ctx) {
            ctx.perpLaunchpadDataSource = new perpLuanchpadDataSource_module_1.PerpLuanchpadDataSourceModule(ctx, endpoint);
        },
    };
};
exports.perpLaunchpadDataSourcePlugin = perpLaunchpadDataSourcePlugin;
const createStakingDataSourcePlugin = (chainIdOrName, providerUrlOrWss, endpoint) => {
    return new context_1.Context(chainIdOrName, providerUrlOrWss)
        .use((0, sdks_perp_launchpad_1.perpLaunchpadPlugin)())
        .use((0, exports.perpLaunchpadDataSourcePlugin)(endpoint));
};
exports.createStakingDataSourcePlugin = createStakingDataSourcePlugin;
